export const now = (): string => new Date().toISOString();

export function randomId(length = 32): string {
  const chars = 'abcdef0123456789';
  let out = '';
  const c = typeof crypto !== 'undefined' && crypto.getRandomValues ? crypto.getRandomValues(new Uint8Array(length)) : null;
  for (let i = 0; i < length; i++) {
    const n = c ? c[i]! % 16 : Math.floor(Math.random() * 16);
    out += chars[n];
  }
  return out;
}

export function safeStringify(value: unknown, max = 2000): string {
  try {
    const s = typeof value === 'string' ? value : JSON.stringify(value);
    return s === undefined ? String(value) : s.length > max ? s.slice(0, max) + '…' : s;
  } catch {
    return String(value);
  }
}

export function truncate(s: string, max: number): string {
  return s.length > max ? s.slice(0, max) + '…[truncated]' : s;
}

export function storage(kind: 'local' | 'session'): Storage | null {
  try {
    const s = kind === 'local' ? window.localStorage : window.sessionStorage;
    const k = '__fetrace_t';
    s.setItem(k, '1');
    s.removeItem(k);
    return s;
  } catch {
    return null;
  }
}

export function readJson<T>(s: Storage | null, key: string, fallback: T): T {
  if (!s) return fallback;
  try {
    const raw = s.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

export function writeJson(s: Storage | null, key: string, value: unknown): void {
  if (!s) return;
  try {
    s.setItem(key, JSON.stringify(value));
  } catch {
    /* quota */
  }
}

export function absoluteUrl(url: string): string {
  try {
    return new URL(url, location.href).href;
  } catch {
    return url;
  }
}

export function isSameOrigin(url: string): boolean {
  try {
    return new URL(url, location.href).origin === location.origin;
  } catch {
    return false;
  }
}

/** CSS-ish selector for breadcrumbs: `button#save.btn.primary` (max 3 classes). */
export function describeElement(el: Element | null): string {
  if (!el) return '';
  const tag = el.tagName.toLowerCase();
  const id = el.id ? '#' + el.id : '';
  const cls = typeof el.className === 'string' && el.className ? '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.') : '';
  const name = el.getAttribute('name') ? `[name=${el.getAttribute('name')}]` : '';
  return `${tag}${id}${cls}${name}`.slice(0, 120);
}

export function errorToParts(error: unknown): { message: string; stack?: string } {
  if (error instanceof Error) return { message: `${error.name}: ${error.message}`, stack: error.stack };
  if (typeof error === 'string') return { message: error };
  return { message: safeStringify(error, 500) };
}
